import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="py-24 sm:py-32 bg-sand">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 text-center">
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="eyebrow mb-4">
          Words From Families
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-serif text-4xl sm:text-5xl text-charcoal tracking-tight leading-tight"
        >
          Trust is earned, one family at a time.
        </motion.h2>

        {/* Empty-ready state */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          data-testid="testimonials-empty-state"
          className="relative mt-12 rounded-[2rem] border border-charcoal/10 bg-white/50 backdrop-blur-sm p-10 sm:p-14 soft-shadow overflow-hidden"
        >
          <div className="pointer-events-none absolute -top-10 -right-6 opacity-10">
            <Quote className="h-40 w-40 text-sage" />
          </div>
          <div className="relative">
            <div className="flex justify-center gap-1 mb-6">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-terracotta text-terracotta" />
              ))}
            </div>
            <p className="font-serif italic text-2xl sm:text-3xl text-charcoal leading-snug">
              “Nicole's story is just beginning — and this space is saved for the
              families she'll care for.”
            </p>
            <p className="mt-6 text-charcoal-soft max-w-lg mx-auto">
              Real reviews from Grand Junction families will appear here soon. If
              Nicole has cared for your loved one, your words would mean the world.
            </p>
            <a
              href={BUSINESS.emailHref}
              data-testid="testimonials-share-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-sage bg-sage/10 px-7 py-3.5 text-sage-700 font-medium hover:bg-sage hover:text-white transition-colors"
            >
              Be the first to share your story
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
